<!-- VIP特权 -->
<template>
  <div class="privilege" @click="goPrivilege">
    <div class="privilege-title">
      <div class="privilege-title-icon"/>
      <div class="privilege-title-name">VIP会员特权</div>
      <div class="privilege-title-icon"/>
    </div>
    <div class="privilege-content">
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-story.png" alt="icon">
        <p>故事畅听</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-new.png" alt="icon">
        <p>重磅新品</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-off.png" alt="icon">
        <p>单购折扣</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-mall.png" alt="icon">
        <p>商城9折</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-youhui.png" alt="icon">
        <p>充值优惠</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-integral.png" alt="icon">
        <p>双倍积分</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-fuli.png" alt="icon">
        <p>免费福利</p>
      </div>
      <div class="privilege-content-icon">
        <img src="@/assets/privilege/icon-service.png" alt="icon">
        <p>专属客服</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppPrivilege',
  props: {},
  data() {
    return {}
  },
  methods: {
    goPrivilege() {
      location.href = 'https://ilisten.idaddy.cn/vip/vipDetail'
    }
  }
}
</script>

<style lang="less" scoped>
.privilege {
  width: 6.7rem;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0 0.04rem 0.16rem 0 rgba(204, 204, 208, 0.32);
  border-radius: 0.12rem;
  overflow: hidden;

  &-title {
    height: 0.96rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #42343c;

    &-icon {
      width: 1rem;
      height: 0.08rem;
      background: url("~@/assets/privilege/icon-shape.png") no-repeat;
      background-size: 100% 100%;
    }

    &-icon:first-child {
      transform: rotate(180deg);
    }

    &-name {
      font-size: 0.38rem;
      font-weight: 700;
      margin: 0 0.24rem;
      text-align: center;
      // 字体渐变色
      background-image: -webkit-gradient(
        linear,
        0 0,
        0 bottom,
        from(#fce06a),
        to(#e8b646)
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  &-content {
    padding: 0.2rem 0;
    height: 4.72rem - 0.96rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;

    &-icon {
      width: 25%;
      text-align: center;

      img {
        width: 0.94rem;
        height: 0.94rem;
      }

      p {
        margin-top: 0.08rem;
        font-size: 0.22rem;
        color: #a0a0a6;
        text-align: center;
      }
    }
  }
}
</style>
